module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("AISearch")]), (_vm.$route.query.algorithmname) ? _c('router-link', {
    attrs: {
      "to": '/Algorithm/' + _vm.$route.query.algorithmname
    }
  }, [_vm._v(" > " + _vm._s(_vm.$route.query.algorithmname))]) : _vm._e(), _c('span', [_vm._v(" > " + _vm._s(_vm.$route.name))])], 1), _c('router-view'), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "Makers"
    }
  }, [_c('h2', [_vm._v("AISearch is brougth to you by:")]), _c('br'), _vm._m(0), _c('br'), _c('h5', [_vm._v("We"), _c('TextChanger', {
    attrs: {
      "arr": ['Code Algorithms', 'do Crazy Science', 'fight in Super Smash', 'Write Papers']
    }
  }), _vm._v("for food or"), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" donations")])], 1), _vm._m(1), _c('br'), _c('input', {
    staticStyle: {
      "opacity": "0"
    },
    attrs: {
      "id": "bitcoinInput",
      "type": "text",
      "value": "184zszakSnvM8ZpfJYwhoyppGdeiEdaKdB"
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col m6 s12"
  }, [_c('img', {
    staticClass: "profile circle responsive-img",
    attrs: {
      "src": require("./assets/Adolfo.png"),
      "alt": "alt"
    }
  }), _c('h3', {
    staticClass: "metaName bold"
  }, [_c('a', {
    attrs: {
      "href": "https://www.researchgate.net/profile/Adolfo_Reyna_Orta",
      "target": "_blank"
    }
  }, [_vm._v("Adolfo Reyna Orta")])]), _c('p', [_vm._v("PhD Student of UABC, Mexicalli, Mexico.")]), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:aeroreyna@gmail.com"
    }
  }, [_vm._v("aeroreyna@gmail.com")])])]), _c('div', {
    staticClass: "col m6 s12"
  }, [_c('img', {
    staticClass: "profile circle responsive-img",
    attrs: {
      "src": require("./assets/Abraham.png"),
      "alt": "alt"
    }
  }), _c('h3', {
    staticClass: "metaName bold"
  }, [_vm._v("Fernando A. Fausto")]), _c('p', [_vm._v("PhD Student of UDG, Guadalajara, Mexico.")]), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:neosbreak@hotmail.com"
    }
  }, [_vm._v("neosbreak@hotmail.com")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('a', {
    attrs: {
      "href": "https://github.com/AISearch/AISearchBackend",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('span', {
    attrs: {
      "onclick": "toClipboard()"
    }
  }, [_vm._v(" "), _c('i', {
    staticClass: "fa fa-bitcoin",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('a', {
    attrs: {
      "href": "http://thesciencematrix.com/",
      "target": "_blank"
    }
  }, [_vm._v(" "), _c('i', {
    staticClass: "fa fa-rss",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69db34b6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 84
// module chunks = 1